import { createSimpleGlobalState } from "src/hooks/simpleGlobalState"

const KEY = "notice-banner-dismissed"

// The full local storage key (createAspState adds the "asp-" prefix).
// _app.tsx keeps this key when it clears local storage after a new deployment.
export const NOTICE_BANNER_STORAGE_KEY = `asp-${KEY}`

// Stores the banner texts the user has closed, one entry per language. This
// way the banner shows at least once in every language. If a text changes, it
// is no longer in the list and the banner shows again in that language.
const { getValue, setValue, resetValue, useValue } = createSimpleGlobalState<
  string[]
>([], KEY)

export {
  getValue as getDismissedNoticeBanners,
  setValue as setDismissedNoticeBanners,
  resetValue as resetDismissedNoticeBanners,
  useValue as useDismissedNoticeBanners,
}
